/* Cozy v3 PDP scripts - loaded once by sections/cozy-v3-base.liquid (product.cozy-v3 template only). */

/* ---------- cozy-v3-shared: smooth scrolling for in-page links ---------- */
/*
  "Learn More About Safety" (#cozy-v3-safety), the "Buy Now" jumps (#cozy-v3-buy) and the hero star rating
  (#cozy-v3-reviews) animate instead of jumping. Only acts on links inside cozy-v3 sections and the rating link
  of the main-product that follows the cozy-v3 marker; honours prefers-reduced-motion and the targets'
  scroll-margin-top (sticky header clearance).
*/
(() => {
  const LINKS = '.cozy-v3-section a[href^="#"], #MainContent > .cozy-v3-base ~ [id$="__main-product"] a.product__rating-link[href^="#"]';
  document.addEventListener('click', (event) => {
    if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    const link = event.target instanceof Element && event.target.closest(LINKS);
    if (!link) return;
    const id = decodeURIComponent(link.getAttribute('href').slice(1));
    const target = id && document.getElementById(id);
    if (!target) return;

    event.preventDefault();
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    target.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'start' });
    if (history.pushState) history.pushState(null, '', '#' + id);
  });
})();

/* ---------- cozy-v3-product ---------- */
(() => {
/*
  Cozy v3 PDP — mobile gallery counter ("1/4").
  Loaded only by sections/cozy-v3-base.liquid (product.cozy-v3 template). Touches nothing outside the
  main-product gallery that follows the cozy-v3 marker section.
*/
(() => {
  const init = () => {
    const gallery = document.querySelector('#MainContent > .cozy-v3-base ~ [id$="__main-product"] media-gallery');
    if (!gallery || gallery.querySelector('.cozy-v3-gallery-counter')) return;

    const slider = gallery.querySelector('slider-element');
    const dots = Array.from(gallery.querySelectorAll('.product__thumbnail:not([hidden])'));
    if (!slider || dots.length < 2) return;

    const counter = document.createElement('span');
    counter.className = 'cozy-v3-gallery-counter';
    counter.setAttribute('aria-hidden', 'true');
    slider.parentElement.appendChild(counter);

    const update = () => {
      const visible = dots.filter((dot) => !dot.hidden);
      const current = visible.findIndex((dot) => dot.getAttribute('aria-current') === 'true');
      counter.textContent = `${Math.max(current, 0) + 1}/${visible.length}`;
    };

    update();
    new MutationObserver(update).observe(gallery.querySelector('.product__thumbnails-list') || gallery, {
      subtree: true,
      attributes: true,
      attributeFilter: ['aria-current', 'hidden'],
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

/*
  "Buy Now" target (#cozy-v3-buy). The template puts the id on the "Quantity" label; if that block was
  removed, fall back to the buy-button wrapper (only when it has no id of its own).
*/
(() => {
  const ensureAnchor = () => {
    if (document.getElementById('cozy-v3-buy')) return;
    const info = document.querySelector('#MainContent > .cozy-v3-base ~ [id$="__main-product"] product-info');
    const target = info && info.querySelector('.product-form-wrapper');
    if (target && !target.id) target.id = 'cozy-v3-buy';
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', ensureAnchor);
  } else {
    ensureAnchor();
  }
})();

/*
  BUY 1 badge (e.g. "FREE SHIPPING"). The theme's Quantity breaks block has no badge setting for BUY 1, so the
  text comes from the "BUY 1 badge" setting of the Cozy v3 page-settings section (sections/cozy-v3-base.liquid).
  Styled like the BUY 2 / BUY 4 gray badge; an empty setting shows no badge.
*/
(() => {
  const syncBadge = () => {
    const config = document.querySelector('#MainContent > .cozy-v3-base [data-cozy-v3-buy-one-badge]');
    const content = document.querySelector(
      '#MainContent > .cozy-v3-base ~ [id$="__main-product"] .quantity-breaks__option[data-quantity-break="1"] .quantity-breaks__content'
    );
    if (!content) return;

    const text = config ? config.dataset.cozyV3BuyOneBadge.trim() : '';
    let badges = content.querySelector('[data-cozy-v3-buy-one-badges]');
    if (!text) {
      if (badges) badges.remove();
      return;
    }
    if (!badges) {
      badges = document.createElement('div');
      badges.className = 'quantity-breaks__badges';
      badges.setAttribute('data-cozy-v3-buy-one-badges', '');
      badges.innerHTML = '<span class="quantity-breaks__badge quantity-breaks__badge--secondary"></span>';
      content.appendChild(badges);
    }
    badges.firstElementChild.textContent = text;
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', syncBadge);
  } else {
    syncBadge();
  }
  // Theme editor: re-apply when the setting changes or the product section re-renders.
  document.addEventListener('shopify:section:load', syncBadge);
})();
})();

/* ---------- cozy-v3-feature-rows ---------- */
(() => {
/* Cozy v3 – Feature rows: mobile slider arrows (CSS scroll-snap track) + adaptive track height. Scoped to its own element. */
;(function () {
  var NAME = 'cozy-v3-feature-rows-slider';
  if (customElements.get(NAME)) return;
  var SLIDER_MQ = '(max-width: 1023.98px)';

  class CozyV3FeatureRowsSlider extends HTMLElement {
    constructor() {
      super();
      this._onClick = this._onClick.bind(this);
      this._onBlockSelect = this._onBlockSelect.bind(this);
      this._onScroll = this._onScroll.bind(this);
      this._sync = this._sync.bind(this);
      this._raf = 0;
    }

    connectedCallback() {
      this.track = this.querySelector('[data-fr-track]');
      if (!this.track) return;
      this._mq = window.matchMedia(SLIDER_MQ);
      this.addEventListener('click', this._onClick);
      this.addEventListener('shopify:block:select', this._onBlockSelect);
      this.track.addEventListener('scroll', this._onScroll, { passive: true });
      if (this._mq.addEventListener) this._mq.addEventListener('change', this._sync);
      if ('ResizeObserver' in window) {
        this._ro = new ResizeObserver(this._onScroll);
        Array.prototype.forEach.call(this.track.children, function (slide) { this._ro.observe(slide); }, this);
      }
      this._sync();
    }

    disconnectedCallback() {
      this.removeEventListener('click', this._onClick);
      this.removeEventListener('shopify:block:select', this._onBlockSelect);
      if (this.track) this.track.removeEventListener('scroll', this._onScroll);
      if (this._mq && this._mq.removeEventListener) this._mq.removeEventListener('change', this._sync);
      if (this._ro) this._ro.disconnect();
      if (this._raf) cancelAnimationFrame(this._raf);
    }

    _slideOf(node) {
      var item = node && node.closest ? node.closest('.cozy-v3-feature-rows__item') : null;
      return item && item.parentElement === this.track ? item : null;
    }

    _onScroll() {
      if (this._raf) return;
      this._raf = requestAnimationFrame(() => {
        this._raf = 0;
        this._sync();
      });
    }

    /* Mobile slider: the track takes the height of the visible slide (Figma slide 1 = 680.69px). Desktop: no height. */
    _sync() {
      if (!this.track) return;
      if (!this._mq.matches) {
        this.track.style.height = '';
        return;
      }
      var width = this.track.clientWidth;
      var slide = width ? this.track.children[Math.round(this.track.scrollLeft / width)] : null;
      if (slide) this.track.style.height = slide.getBoundingClientRect().height + 'px';
    }

    goTo(index) {
      var count = this.track.children.length;
      if (!count) return;
      index = Math.max(0, Math.min(count - 1, index));
      var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.track.scrollTo({ left: index * this.track.clientWidth, behavior: reduce ? 'auto' : 'smooth' });
    }

    _onClick(event) {
      var button = event.target.closest('[data-fr-prev], [data-fr-next]');
      if (!button || button.disabled || !this.contains(button)) return;
      var item = this._slideOf(button);
      if (!item) return;
      var index = Array.prototype.indexOf.call(this.track.children, item);
      this.goTo(index + (button.hasAttribute('data-fr-next') ? 1 : -1));
    }

    _onBlockSelect(event) {
      var item = this._slideOf(event.target);
      if (!item) return;
      var index = Array.prototype.indexOf.call(this.track.children, item);
      this.track.scrollTo({ left: index * this.track.clientWidth, behavior: 'auto' });
    }
  }

  customElements.define(NAME, CozyV3FeatureRowsSlider);
})();

/* Cozy v3 – Feature rows: row-button popup (Figma 26:33). Native <dialog>; scoped to its own element. */
;(function () {
  var NAME = 'cozy-v3-feature-rows-popup';
  if (customElements.get(NAME)) return;

  class CozyV3FeatureRowsPopup extends HTMLElement {
    connectedCallback() {
      this.dialog = this.querySelector('dialog');
      this.opener = this.querySelector('[data-fr-popup-open]');
      if (!this.dialog || !this.opener || this.bound) return;
      this.bound = true;

      this.opener.addEventListener('click', () => this.open());
      // Click on the dimmed backdrop (outside the modal content) closes it.
      this.dialog.addEventListener('click', (event) => {
        if (event.target === this.dialog) this.close();
      });
      this.dialog.querySelectorAll('[data-fr-popup-close], [data-fr-popup-dismiss]').forEach((el) => {
        el.addEventListener('click', () => this.close());
      });
      // Esc closes natively: 'cancel' fires synchronously on the key press; 'close' is a fallback for any
      // other programmatic close (it is dispatched asynchronously).
      this.dialog.addEventListener('cancel', () => this.unlockScroll());
      this.dialog.addEventListener('close', () => {
        if (!this.dialog.open) this.unlockScroll();
      });
    }

    disconnectedCallback() {
      if (this.dialog && this.dialog.open) this.dialog.close();
      this.unlockScroll();
    }

    open() {
      if (typeof this.dialog.showModal !== 'function' || this.dialog.open) return;
      if (!this.locked) {
        // Lock on <body>, not <html>: the theme's body has its own overflow, so hiding overflow on <html> turns
        // <body> into a scroll container and the sticky header stops sticking (the top bar disappears).
        // The theme already sets scrollbar-gutter: stable on <html>, so the page doesn't shift sideways.
        this.previousBodyOverflow = document.body.style.overflow;
        document.body.style.overflow = 'hidden';
        this.locked = true;
      }
      this.dialog.showModal();
    }

    close() {
      if (this.dialog.open) this.dialog.close();
      this.unlockScroll();
    }

    unlockScroll() {
      if (!this.locked) return;
      document.body.style.overflow = this.previousBodyOverflow || '';
      this.locked = false;
    }
  }

  customElements.define(NAME, CozyV3FeatureRowsPopup);

  // Other triggers (e.g. the CozyCase card "Learn more" in the product info) open a row popup:
  // <a href="/fallback" data-cozy-v3-popup-open="cozy-case"> opens #cozy-v3-popup-cozy-case; if no popup has that
  // ID but the page has exactly one row popup, that one opens. With no popup on the page the link is followed.
  // Capture phase + stopPropagation so the theme's page-transition link handler can't navigate away first.
  const findPopupHost = (key) => {
    const exact = document.getElementById('cozy-v3-popup-' + key);
    if (exact && exact.closest(NAME)) return exact.closest(NAME);
    const hosts = document.querySelectorAll(NAME);
    return hosts.length === 1 ? hosts[0] : null;
  };

  document.addEventListener('click', (event) => {
    if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    const trigger = event.target instanceof Element && event.target.closest('[data-cozy-v3-popup-open]');
    if (!trigger) return;
    const host = findPopupHost(trigger.getAttribute('data-cozy-v3-popup-open'));
    if (!host || typeof host.open !== 'function') return;
    event.preventDefault();
    event.stopPropagation();
    host.open();
  }, true);
})();
})();

/* ---------- cozy-v3-coverage ---------- */
(() => {
/* Cozy v3 – Coverage: selectable room-size options (optional per-option image). Scoped to its own element. */
;(function () {
  var NAME = 'cozy-v3-coverage-options';
  if (customElements.get(NAME)) return;

  class CozyV3CoverageOptions extends HTMLElement {
    constructor() {
      super();
      this._onClick = this._onClick.bind(this);
      this._onBlockSelect = this._onBlockSelect.bind(this);
    }

    connectedCallback() {
      this.addEventListener('click', this._onClick);
      this.addEventListener('shopify:block:select', this._onBlockSelect);
    }

    disconnectedCallback() {
      this.removeEventListener('click', this._onClick);
      this.removeEventListener('shopify:block:select', this._onBlockSelect);
    }

    _onClick(event) {
      var option = event.target.closest('[data-cv-option]');
      if (!option || !this.contains(option)) return;
      this.select(option.getAttribute('data-cv-option'));
    }

    _onBlockSelect(event) {
      var option = event.target && event.target.closest ? event.target.closest('[data-cv-option]') : null;
      if (option && this.contains(option)) this.select(option.getAttribute('data-cv-option'));
    }

    select(index) {
      this.querySelectorAll('[data-cv-option]').forEach(function (option) {
        var active = option.getAttribute('data-cv-option') === index;
        option.classList.toggle('is-selected', active);
        option.setAttribute('aria-pressed', active ? 'true' : 'false');
      });
      this.querySelectorAll('[data-cv-media]').forEach(function (media) {
        media.hidden = media.getAttribute('data-cv-media') !== index;
      });
    }
  }

  customElements.define(NAME, CozyV3CoverageOptions);
})();
})();

/* ---------- cozy-v3-rooms ---------- */
(() => {
(() => {
  var NAME = 'cozy-v3-rooms-gallery';
  if (!window.customElements || customElements.get(NAME)) return;

  class CozyV3RoomsGallery extends HTMLElement {
    connectedCallback() {
      if (this._bound) return;
      this._bound = true;
      this._onClick = this._onClick.bind(this);
      this._onBlockSelect = this._onBlockSelect.bind(this);
      this.addEventListener('click', this._onClick);
      // Theme editor: show the room whose block is selected (event bubbles from the slide).
      this.addEventListener('shopify:block:select', this._onBlockSelect);
    }

    disconnectedCallback() {
      this.removeEventListener('click', this._onClick);
      this.removeEventListener('shopify:block:select', this._onBlockSelect);
      this._bound = false;
    }

    _onBlockSelect(event) {
      var slide = event.target.closest && event.target.closest('.cozy-v3-rooms__slide');
      if (!slide || !this.contains(slide)) return;
      this.select(parseInt(slide.getAttribute('data-index'), 10) || 0);
    }

    _onClick(event) {
      var thumb = event.target.closest('.cozy-v3-rooms__thumb');
      if (!thumb || !this.contains(thumb)) return;
      this.select(parseInt(thumb.getAttribute('data-index'), 10) || 0);
    }

    select(index) {
      var slides = this.querySelectorAll('.cozy-v3-rooms__slide');
      var thumbs = this.querySelectorAll('.cozy-v3-rooms__thumb');
      if (!slides[index]) return;

      Array.prototype.forEach.call(slides, function (slide, i) {
        slide.classList.toggle('is-active', i === index);
      });

      Array.prototype.forEach.call(thumbs, function (thumb, i) {
        var active = i === index;
        thumb.classList.toggle('is-active', active);
        thumb.setAttribute('aria-pressed', active ? 'true' : 'false');
      });

      var img = slides[index].querySelector('img[loading="lazy"]');
      if (img) img.loading = 'eager';
    }
  }

  customElements.define(NAME, CozyV3RoomsGallery);
})();
})();

/* ---------- cozy-v3-reviews ---------- */
(() => {
(() => {
  var NAME = 'cozy-v3-reviews-toggle';
  if (!window.customElements || customElements.get(NAME)) return;

  // Judge.me revamp widget items + legacy widget items.
  var ITEM_SELECTOR = '.jm-review-item, .jdgm-rev';
  var VISIBLE_WHEN_COLLAPSED = 1;

  class CozyV3ReviewsToggle extends HTMLElement {
    connectedCallback() {
      if (this._bound) return;
      this._bound = true;

      this._wrap = this.querySelector('.cozy-v3-reviews__more-wrap');
      this._button = this.querySelector('.cozy-v3-reviews__more');
      this._onClick = this._onClick.bind(this);
      this._scheduleUpdate = this._scheduleUpdate.bind(this);

      if (this._button) this._button.addEventListener('click', this._onClick);

      // Judge.me renders its reviews asynchronously; watch only our own subtree.
      this._observer = new MutationObserver(this._scheduleUpdate);
      this._observer.observe(this, { childList: true, subtree: true });
      this._update();
    }

    disconnectedCallback() {
      if (this._button) this._button.removeEventListener('click', this._onClick);
      if (this._observer) this._observer.disconnect();
      if (this._raf) cancelAnimationFrame(this._raf);
      this._bound = false;
    }

    _scheduleUpdate() {
      if (this._raf) return;
      this._raf = requestAnimationFrame(
        function () {
          this._raf = null;
          this._update();
        }.bind(this)
      );
    }

    _update() {
      if (!this._wrap) return;
      var collapsed = this.hasAttribute('data-collapsed');
      var count = this.querySelectorAll(ITEM_SELECTOR).length;
      var hasMore = collapsed && count > VISIBLE_WHEN_COLLAPSED;
      if (this._wrap.hidden === hasMore) this._wrap.hidden = !hasMore;
    }

    _onClick() {
      this.removeAttribute('data-collapsed');
      if (this._button) this._button.setAttribute('aria-expanded', 'true');
      if (this._wrap) this._wrap.hidden = true;
      if (this._observer) this._observer.disconnect();

      // Move focus to the first newly revealed review for keyboard / screen reader users.
      var items = this.querySelectorAll(ITEM_SELECTOR);
      var next = items[VISIBLE_WHEN_COLLAPSED];
      if (next) {
        if (!next.hasAttribute('tabindex')) next.setAttribute('tabindex', '-1');
        next.focus({ preventScroll: true });
      }
    }
  }

  customElements.define(NAME, CozyV3ReviewsToggle);
})();
})();

/* ---------- cozy-v3-remote ---------- */
(() => {
/* Cozy v3 – Remote: mobile feature hotspots. Self-contained (safe to concatenate), no document listeners. */
(() => {
  const NAME = 'cozy-v3-remote-hotspots';
  if (customElements.get(NAME)) return;

  class CozyV3RemoteHotspots extends HTMLElement {
    constructor() {
      super();
      this.handleClick = this.handleClick.bind(this);
      this.handleKeydown = this.handleKeydown.bind(this);
    }

    connectedCallback() {
      this.addEventListener('click', this.handleClick);
      this.addEventListener('keydown', this.handleKeydown);
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.handleClick);
      this.removeEventListener('keydown', this.handleKeydown);
    }

    getButtons() {
      return Array.from(this.querySelectorAll('.cozy-v3-remote__spot-btn'));
    }

    getTip(button) {
      const id = button.getAttribute('aria-controls');
      if (!id) return null;
      return Array.from(this.querySelectorAll('.cozy-v3-remote__tip')).find((tip) => tip.id === id) || null;
    }

    setOpen(button, open) {
      const tip = this.getTip(button);
      const spot = button.closest('.cozy-v3-remote__spot');
      button.setAttribute('aria-expanded', open ? 'true' : 'false');
      if (tip) tip.hidden = !open;
      if (spot) spot.classList.toggle('is-active', open);
    }

    closeAll(except) {
      this.getButtons().forEach((button) => {
        if (button !== except && button.getAttribute('aria-expanded') === 'true') this.setOpen(button, false);
      });
    }

    handleClick(event) {
      const button = event.target.closest('.cozy-v3-remote__spot-btn');
      if (button && this.contains(button)) {
        const isOpen = button.getAttribute('aria-expanded') === 'true';
        this.closeAll(button);
        this.setOpen(button, !isOpen);
        return;
      }
      // Tap anywhere else inside the image (but not inside an open tooltip) closes it.
      if (!event.target.closest('.cozy-v3-remote__tip')) this.closeAll();
    }

    handleKeydown(event) {
      if (event.key !== 'Escape') return;
      const open = this.querySelector('.cozy-v3-remote__spot-btn[aria-expanded="true"]');
      if (!open) return;
      this.closeAll();
      open.focus();
    }
  }

  customElements.define(NAME, CozyV3RemoteHotspots);
})();
})();

/* ---------- cozy-v3-testimonials ---------- */
(() => {
(() => {
  var NAME = 'cozy-v3-testimonials-carousel';
  if (customElements.get(NAME)) return;

  class CozyV3TestimonialsCarousel extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-track]');
      if (!this.track) return;

      this.cards = Array.prototype.slice.call(this.querySelectorAll('[data-card]'));
      this.dots = Array.prototype.slice.call(this.querySelectorAll('[data-dot]'));
      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.wantPlay = this.dataset.autoplay === 'true' && !this.reducedMotion;
      this.active = 0;
      this.inView = false;
      this.soundOn = false;
      this.handleOtherSound = this.handleOtherSound.bind(this);

      this.handleScroll = this.handleScroll.bind(this);
      this.track.addEventListener('scroll', this.handleScroll, { passive: true });

      this.dots.forEach(
        function (dot, index) {
          dot.addEventListener(
            'click',
            function () {
              this.select(index, true);
            }.bind(this)
          );
        }.bind(this)
      );

      this.cards.forEach(
        function (card, index) {
          var video = card.querySelector('[data-video]');
          var toggle = card.querySelector('[data-toggle]');
          var sound = card.querySelector('[data-sound]');
          if (!video) return;

          var sync = function () {
            var playing = !video.paused;
            card.classList.toggle('is-playing', playing);
            if (toggle) toggle.setAttribute('aria-label', playing ? 'Pause video' : 'Play video');
          };
          video.addEventListener('play', sync);
          video.addEventListener('pause', sync);
          video.addEventListener('playing', function () {
            video.classList.add('is-ready');
          });

          if (toggle) {
            toggle.addEventListener(
              'click',
              function () {
                this.toggle(index);
              }.bind(this)
            );
          }

          if (sound) {
            sound.addEventListener(
              'click',
              function () {
                this.toggleSound(index);
              }.bind(this)
            );
          }
        }.bind(this)
      );
      document.addEventListener('cozy-v3:sound-on', this.handleOtherSound);

      // Theme editor: bring the selected block into view.
      this.addEventListener(
        'shopify:block:select',
        function (event) {
          var index = this.cards.indexOf(event.target);
          if (index > -1) this.select(index, true);
        }.bind(this)
      );

      if ('IntersectionObserver' in window) {
        this.observer = new IntersectionObserver(
          function (entries) {
            this.inView = entries[entries.length - 1].isIntersecting;
            this.syncVideos();
          }.bind(this),
          { threshold: 0.35 }
        );
        this.observer.observe(this);
      } else {
        this.inView = true;
      }

      this.render();
      this.syncVideos();
    }

    disconnectedCallback() {
      if (this.observer) this.observer.disconnect();
      document.removeEventListener('cozy-v3:sound-on', this.handleOtherSound);
      if (this.track) this.track.removeEventListener('scroll', this.handleScroll);
      clearTimeout(this.scrollTimer);
    }

    isFullyVisible(card) {
      var left = this.track.scrollLeft;
      var start = card.offsetLeft;
      var end = start + card.offsetWidth;
      return start >= left - 2 && end <= left + this.track.clientWidth + 2;
    }

    handleScroll() {
      clearTimeout(this.scrollTimer);
      this.scrollTimer = setTimeout(
        function () {
          var current = this.cards[this.active];
          if (current && this.isFullyVisible(current)) return;
          for (var i = 0; i < this.cards.length; i++) {
            if (this.isFullyVisible(this.cards[i])) {
              this.active = i;
              this.render();
              this.syncVideos();
              return;
            }
          }
        }.bind(this),
        120
      );
    }

    select(index, scroll) {
      var card = this.cards[index];
      if (!card) return;
      this.active = index;
      if (scroll && !this.isFullyVisible(card)) {
        var padding = parseFloat(window.getComputedStyle(this.track).paddingLeft) || 0;
        this.track.scrollTo({
          left: Math.max(0, card.offsetLeft - padding),
          behavior: this.reducedMotion ? 'auto' : 'smooth',
        });
      }
      this.render();
      this.syncVideos();
    }

    toggle(index) {
      var video = this.cards[index] && this.cards[index].querySelector('[data-video]');
      if (!video) return;
      if (index !== this.active) {
        this.wantPlay = true;
        this.select(index, true);
        return;
      }
      this.wantPlay = video.paused;
      this.syncVideos();
    }

    // Autoplay has to start muted (browser rule); the speaker button turns sound on and plays that card.
    toggleSound(index) {
      this.setSound(!this.soundOn);
      if (!this.soundOn) return;
      this.wantPlay = true;
      if (index !== this.active) {
        this.select(index, true);
        return;
      }
      this.syncVideos();
    }

    setSound(on) {
      this.soundOn = on;
      this.cards.forEach(function (card) {
        var video = card.querySelector('[data-video]');
        var sound = card.querySelector('[data-sound]');
        if (video) video.muted = !on;
        if (sound) sound.setAttribute('aria-label', on ? 'Mute video' : 'Unmute video');
      });
      this.classList.toggle('is-sound-on', on);
      if (on) document.dispatchEvent(new CustomEvent('cozy-v3:sound-on', { detail: this }));
    }

    // Only one Cozy v3 video plays sound at a time.
    handleOtherSound(event) {
      if (event.detail !== this && this.soundOn) this.setSound(false);
    }

    play(video) {
      var promise = video.play();
      if (!promise || !promise.catch) return;
      promise.catch(
        function (error) {
          // Some browsers (e.g. iOS) refuse sound without a fresh tap: keep playing muted instead.
          if (error && error.name === 'NotAllowedError' && !video.muted) {
            this.setSound(false);
            video.play().catch(function () {});
          }
        }.bind(this)
      );
    }

    render() {
      this.cards.forEach(
        function (card, index) {
          card.classList.toggle('is-active', index === this.active);
        }.bind(this)
      );
      this.dots.forEach(
        function (dot, index) {
          var isActive = index === this.active;
          dot.classList.toggle('is-active', isActive);
          if (isActive) {
            dot.setAttribute('aria-current', 'true');
          } else {
            dot.removeAttribute('aria-current');
          }
        }.bind(this)
      );
    }

    syncVideos() {
      this.cards.forEach(
        function (card, index) {
          var video = card.querySelector('[data-video]');
          if (!video) return;
          if (index === this.active && this.inView && this.wantPlay) {
            this.play(video);
          } else if (!video.paused) {
            video.pause();
          }
        }.bind(this)
      );
    }
  }

  customElements.define(NAME, CozyV3TestimonialsCarousel);
})();
})();

/* ---------- cozy-v3-video ---------- */
(() => {
(() => {
  var NAME = 'cozy-v3-video-player';
  if (customElements.get(NAME)) return;

  class CozyV3VideoPlayer extends HTMLElement {
    connectedCallback() {
      this.videos = Array.prototype.slice.call(this.querySelectorAll('[data-video]'));
      if (!this.videos.length) return;

      this.button = this.querySelector('[data-toggle]');
      this.soundButton = this.querySelector('[data-sound]');
      this.soundOn = false;
      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.wantPlay = this.dataset.autoplay === 'true' && !this.reducedMotion;
      this.inView = false;

      this.sync = this.sync.bind(this);
      this.update = this.update.bind(this);
      this.handleOtherSound = this.handleOtherSound.bind(this);

      this.videos.forEach(
        function (video) {
          video.addEventListener('play', this.update);
          video.addEventListener('pause', this.update);
          video.addEventListener('playing', function () {
            video.classList.add('is-ready');
          });
        }.bind(this)
      );

      if (this.button) {
        this.button.addEventListener(
          'click',
          function () {
            this.wantPlay = !this.isPlaying();
            this.sync();
          }.bind(this)
        );
      }

      // Autoplay has to start muted (browser rule); the speaker button turns sound on and starts playback.
      if (this.soundButton) {
        this.soundButton.addEventListener(
          'click',
          function () {
            this.setSound(!this.soundOn);
            if (this.soundOn && !this.isPlaying()) {
              this.wantPlay = true;
              this.sync();
            }
          }.bind(this)
        );
      }
      document.addEventListener('cozy-v3:sound-on', this.handleOtherSound);

      this.breakpoint = window.matchMedia('(min-width: 768px)');
      if (this.breakpoint.addEventListener) {
        this.breakpoint.addEventListener('change', this.sync);
      } else if (this.breakpoint.addListener) {
        this.breakpoint.addListener(this.sync);
      }

      if ('IntersectionObserver' in window) {
        this.observer = new IntersectionObserver(
          function (entries) {
            this.inView = entries[entries.length - 1].isIntersecting;
            this.sync();
          }.bind(this),
          { threshold: 0.25 }
        );
        this.observer.observe(this);
      } else {
        this.inView = true;
        this.sync();
      }
    }

    disconnectedCallback() {
      if (this.observer) this.observer.disconnect();
      document.removeEventListener('cozy-v3:sound-on', this.handleOtherSound);
      if (this.breakpoint) {
        if (this.breakpoint.removeEventListener) {
          this.breakpoint.removeEventListener('change', this.sync);
        } else if (this.breakpoint.removeListener) {
          this.breakpoint.removeListener(this.sync);
        }
      }
    }

    currentVideo() {
      for (var i = 0; i < this.videos.length; i++) {
        if (this.videos[i].getClientRects().length) return this.videos[i];
      }
      return null;
    }

    isPlaying() {
      return this.videos.some(function (video) {
        return !video.paused;
      });
    }

    sync() {
      var current = this.currentVideo();
      this.videos.forEach(
        function (video) {
          if (video === current && this.inView && this.wantPlay) {
            this.play(video);
          } else if (!video.paused) {
            video.pause();
          }
        }.bind(this)
      );
      this.update();
    }

    play(video) {
      var promise = video.play();
      if (!promise || !promise.catch) return;
      promise.catch(
        function (error) {
          // Some browsers (e.g. iOS) refuse sound without a fresh tap: keep playing muted instead.
          if (error && error.name === 'NotAllowedError' && !video.muted) {
            this.setSound(false);
            video.play().catch(function () {});
          }
        }.bind(this)
      );
    }

    setSound(on) {
      this.soundOn = on;
      this.videos.forEach(function (video) {
        video.muted = !on;
      });
      this.classList.toggle('is-sound-on', on);
      if (this.soundButton) this.soundButton.setAttribute('aria-label', on ? 'Mute video' : 'Unmute video');
      if (on) document.dispatchEvent(new CustomEvent('cozy-v3:sound-on', { detail: this }));
    }

    // Only one Cozy v3 video plays sound at a time.
    handleOtherSound(event) {
      if (event.detail !== this && this.soundOn) this.setSound(false);
    }

    update() {
      var playing = this.isPlaying();
      this.classList.toggle('is-playing', playing);
      if (this.button) this.button.setAttribute('aria-label', playing ? 'Pause video' : 'Play video');
    }
  }

  customElements.define(NAME, CozyV3VideoPlayer);
})();
})();
